const route = (entry, resolve) => ({
  template: '<' + entry + '></' + entry + '>',
  resolve: {
    async: ['$q', function ($q) {
      const defer = $q.defer();

      resolve(defer.resolve);
      return defer.promise;
    }]
  }
});

const rootRouteTemplate = `<lba-route-root target="vm.target"></lba-route-root>`;
const redirectTemplate = `<lba-redirect></lba-redirect>`;

function injectTarget(target) {
  return target;
}

function rootRouteController(target) {
  const vm = this;
  vm.target = target;
}

export default app => {
  const $inject = ['$routeProvider'];

  const RouterConfig = function ($routeProvider) {
    $routeProvider

      .when('/', {redirectTo: '/debtors'})

      .when('/sign-in', { redirectTo: '/debtors' })

      //#region *************************** DEBTORS START ***************************

      

      .when('/debtors', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorList');
          }]
        }
      })

      .when('/debtors/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorAddResource');
          }]
        }
      })

      .when('/debtors/:debtorId',
        {redirectTo: '/debtors/:debtorId/info'})

      .when('/debtors/:debtorId/:tab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('Debtor');
          }]
        }
      })


      .when('/debtors/:debtorId/:tab/debtor-order-number-codes',
        {redirectTo: '/debtors/:debtorId/:tab/debtor-order-number-codes/0'})

      .when('/debtors/:debtorId/:tab/debtor-order-number-codes/:debtorOrderNumberCodesIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorOrderNumberCodesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/terms-and-conditions',
        {redirectTo: '/debtors/:debtorId/:tab/terms-and-conditions/0'})

      .when('/debtors/:debtorId/:tab/terms-and-conditions/:debtorTermsItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorTermsAndConditionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/debtor-approvers',
        {redirectTo: '/debtors/:debtorId/:tab/debtor-approvers/0'})

      .when('/debtors/:debtorId/:tab/debtor-approvers/:debtorApproversIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorApproversItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/debtor-approvers/:debtorApproversIndex/policycodetiers/:policyCodeTiersIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorApproversPolicyCodeTiersItem');
          }]
        }
      })



      .when('/debtors/:debtorId/:tab/debtor-approvers/:debtorApproversIndex/travellers/:travellersIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorApproversTravellersItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/',
        {redirectTo: '/debtors/:debtorId/:tab/itinerary-policies/0/general'})

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex',
        {redirectTo: '/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general'})

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/:itineraryPoliciesTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/employee-types/:ItinPolItemIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesItemsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/travel-intent-questions/:TravelIntentQuestionIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('TravelIntentQuestionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/travel-intent-questions/:TravelIntentQuestionIndex/children/:TravelIntentQuestionChildIndex', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('TravelIntentQuestionsChildrenItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-policies/:flightBenchPolItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightBenchmarksPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-exceptions/:flightBenchExcItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightBenchmarksExceptionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/ndc-qualifiers/:flightNdcQualifiersItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightNDCQualifiersItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policies/:flightPolItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/break-policy-reasons/:flightPolExcItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightPolicyExceptionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/break-policy-exceptions/:flightPolExcSetItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightPolicyExceptionSettingsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/break-policy-rules/:flightBreakPolRulItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightBreakPolicyRulesItem');
          }]
        }
      })

      
      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/best-fare-of-flights/:flightBestFareItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesFlightBestFareOfFlightItem');
          }]
        }
      })
      

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policies/:railPolItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesRailPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policy-exceptions/:railPolExcItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesRailPolicyExceptionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/policies/:hotelPolItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesHotelPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/break-policy-reasons/:hotelPolExcItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesHotelPolicyExceptionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/break-policy-exceptions/:ItinPolExcSetItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesHotelPolicyExceptionSettingsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/break-policy-rules/:ItinPolBreakPolRulesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesHotelBreakPolicyRulesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/car-suppliers/:carPolItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarPoliciesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/break-policy-reasons/:carPolExcItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarPolicyExceptionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/break-policy-exceptions/:carPolExcSetItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarPolicyExceptionSettingsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-preferred/:carPolPrefItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarPolicyPreferredItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-restriction/:carPolRestrictedItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarPolicyRestrictionItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/break-policy-rules/:carPolBreakPolRulesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ItineraryPoliciesCarBreakPolicyRulesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/company-references/company-references/:compRefItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CompanyReferencesGridItem');
          }]
        }
      })

      .when('/debtors/:debtorId/company-references/company-references/:compRefItem/children/:compRefChildItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CompanyReferencesChildrenItem');
          }]
        }
      })

      .when('/debtors/:debtorId/ndc-pnr-remarks/ndc-servicing-utility-service-fee-remarks/:ndcPnrRemarksItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NDCPNRRemarksGridItem');
          }]
        }
      })

        .when('/debtors/:debtorId/roster-management/reference-mapping/:referencesItem', {
          template: rootRouteTemplate,
          controller: ['targetName', rootRouteController],
          controllerAs: 'vm',
          resolve: {
              targetName: [() => {
                  return injectTarget('RosterManagementReferenceGridItem');
              }]
           }
        })

      .when('/debtors/:debtorId/agency/agency-credit-cards/:debtAgCCItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AgencyCreditCardsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/agency-reason-codes/:debAgReCoItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorAgencyReasonCodesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/payment-configurations/:payConItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PaymentConfigurationsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PaymentTypesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PaymentTypesConfigurationsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem/suppliers/:payConSupItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/virtual-credit-card-configurations/:vccConfigItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VirtualCreditCardConfigurationsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/agency/virtual-credit-card-configurations/:vccConfigItem/enhanced-data-mappings/:vccConfigEnhancedDataMapItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VirtualCreditCardIssuerEnhancedDataMappingsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/all-sectors/reasons-for-change/:debReasonChangeItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ReasonForChangeItem');
          }]
        }
      })

      .when('/debtors/:debtorId/all-sectors/agency-change-fees/:debAgChangeFeesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorAgencyChangeFeesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/flight-sectors/one-way-fare-rules/:oneWayFarRuItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('OneWayFareRulesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/flight-sectors/flight-search-windows/:flightSearchWindowItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FlightSearchWindowItem');
          }]
        }
      })

      .when('/debtors/:debtorId/flight-sectors/combinable-fare-rules/:combFareRulesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CombinableFareRulesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/hotel-sectors/cities/:hotConRadCitiesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelConfigurationRadiusCitiesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/hotel-sectors/hotel-payment-narratives/:hotConPaymentNarrativesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelConfigurationPaymentNarrativesItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsMiQuestionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem/questions/:question', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsMiQuestionsItemQuestionsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem/corporate-identifiers/:corpId', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsCorporateIdentifiersItem');
          }]
        }
      })
      
      .when('/debtors/:debtorId/gds/gds/:GdsItem/supplier-configuration/:GdsSplConfigurationItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsSupplierConfigurationsGridItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem/supplier-configuration/:GdsSplConfigurationItem/country-pair/:CountryPairItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorGdsSupplierConfigurationCountryPairGridItem');
          }]
        }
      })

      .when('/debtors/:debtorId/gds/gds/:GdsItem/hotel-aggregators/:HotelAggItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
             return injectTarget('DebtorGdsHotelAggsItem');
          }]
        }
      })
     
      .when('/debtors/:debtorId/pnr-remarks/service-fee-remarks/:agencySvcFeeRmkItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AgencyServiceFeeRemarksItem');
          }]
        }
      })

      .when('/debtors/:debtorId/:tab/rail-supplier-settings',
        {redirectTo: '/debtors/:debtorId/:tab/rail-supplier-settings/0'})

      .when('/debtors/:debtorId/:tab/rail-supplier-settings/:railSuppSettingItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailSupplierSettingsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/products/debtor-products/:debtProductItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorProductsItem');
          }]
        }
      })

      .when('/debtors/:debtorId/products/debtor-products/:debtProductItem/disabled-travellers-for-notifications/:dsbldTrvlrItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorProductRiskSetting5Item');
          }]
        }
      })

      .when('/debtors/:debtorId/products/debtor-products/:debtProductItem/notifications-for-travellers-disabled/:dsbldTrvlrHotelReviewItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('DebtorProductHotelReviewSetting4Item');
          }]
        }
      })

      .when('/debtors/:debtorId/users/sync-selected-profiles-only/:selProfileItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('SeletedProfilesForUserCreationItem');
          }]
        }
      })

      .when('/debtors/:debtorId/authentication/client-ip-addresses/:clientIpAddr', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ClientIpAddressItem');
          }]
        }
      })


      //#endregion *************************** DEBTORS END ***************************


      /**
       *************************** SETTINGS START ***************************
       */

      .when('/settings',
        {redirectTo: '/settings/settings-misc'})


      .when('/settings/:tab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('SettingsResource');
          }]
        }
      })

      .when('/settings/settings-misc/error-messages/:ErMesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('ErrorMessagesItem');
          }]
        }
      })

      .when('/settings/settings-misc/terms-&-condition/:termsItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('TermsAndConditionsItem');
          }]
        }
      })

      .when('/settings/settings-misc/vehicle-defaults/:vehicleDefaultItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VehicleDefaultsItem');
          }]
        }
      })

      .when('/settings/settings-misc/optional-services-industry-sub-codes/:optionalServiceIndustrySubCodeItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('OptionalServiceIndustrySubCodesItem');
          }]
        }
      })

      .when('/settings/settings-misc/flight-fare-data/:flFareDataItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FlightFareDataItem');
          }]
        }
      })

      .when('/settings/settings-misc/flight-fare-bucket-data/:ffbcFlightFareBucketClassesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FlightFareBucketClassesItem');
          }]
        }
      })

      .when('/settings/guest-travellers-titles/guest-travellers-titles/:gusTravTitleItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GuestTravellersTitlesGridItem');
          }]
        }
      })

      .when('/settings/gds/gds/:GdsItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GdssettingsItem');
          }]
        }
      })

      .when('/settings/gds/gds/:GdsItem/supplier-configuration/:GdsSplConfigurationItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GdsSupplierConfigurationsGridItem');
          }]
        }
      })

      .when('/settings/gds/gds/:GdsItem/supplier-configuration/:GdsSplConfigurationItem/country-pair/:CountryPairItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GdsSupplierConfigurationCountryPairGridItem');
          }]
        }
      })

      .when('/settings/gds/gds/:GdsItem/post-booking-changes/:GdsPBCItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GdsPostBookingChangesItem');
          }]
        }
      })

      .when('/settings/gds/gds/:GdsItem/post-booking-changes/:GdsPBCItem/country-pair/:CountryPairItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('GdsPostBookingChangesCountryPairGridItem');
          }]
        }
      })

      .when('/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CountryPnrFinishingRemarksGridItem');
          }]
        }
      })

      .when('/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem/gds-remarks/:GdsRemarksItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CountryPnrFinishingRemarksGdsRemarksItem');
          }]
        }
      })

      .when('/settings/ndc-settings/ndc-queue/:NdcQueueItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NdcQueueGridItem');
          }]
        }
      })

      .when('/settings/ndc-settings/ndc-queue/:NdcQueueItem/queue-mapping/:QueueMappingItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NdcQueueMappingItem');
          }]
        }
      })

      .when('/settings/ndc-settings/ndc-country-pnr-remarks/:NdcCountryPNRRemarkItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NdcCountryPNRRemarkGridItem');
          }]
        }
      })

      .when('/settings/ndc-settings/ndc-pcc-mapping/:NdcPccMappingItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NdcPccMappingGridItem');
          }]
        }
      })

      .when('/settings/ndc-settings/ndc-pcc-mapping/:NdcPccMappingItem/pcc-mapping/:PccGdsMappingItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('NdcPccMappingGdsPccMappingGridItem');
          }]
        }
      })

      .when('/settings/post-booking-changes/post-booking-changes-lead-time/:bkgLeadTimeItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PostBookingChangeLeadTimeGridItem');
          }]
        }
      })

      /**
       *************************** SETTINGS END ***************************
       */


      /**
       *************************** CREDIT CARD START ***************************
       */

      .when('/credit-cards', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CreditCardsList');
          }]
        }
      })

      .when('/credit-cards/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CreditCardsAddResource');
          }]
        }
      })

      .when('/credit-cards/:ccId',
        {redirectTo: '/credit-cards/:ccId/info'})

      .when('/credit-cards/:ccId/:ccTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CreditCardsResource');
          }]
        }
      })

      /**
       *************************** CREDIT CARD END ***************************
       */


      /**
       *************************** Airline Carriers START ***************************
       */


      .when('/airline-carriers', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarriersList');
          }]
        }
      })

      .when('/airline-carriers/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarriersAddResource');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId',
        {redirectTo: '/airline-carriers/:airCarriersId/info'})

      .when('/airline-carriers/:airCarriersId/:airCarriersTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarriersResource');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/country-data/:AirCountryDataItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierCountryDataGridItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareClassesGridItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem/country-fare-class/:AirFareClsCuFareClsItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareClassesCountryFareClassItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/branded-fare/:AirCarrierBrandedFareItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierBrandedFareGridItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareGdsSettingsItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareGdsSettingsFaresItem');
          }]
        }
      })

      .when('/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem/gds-fare-settings/:airCarrierGDSFarSetItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareGdsSettingsFaresItemFareDataItem');
          }]
        }
      })


      .when('/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/price-quote/:airGdsQuotesItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirlineCarrierFareGdsSettingsPriceQuotesItem');
          }]
        }
      })

      /**
       *************************** Airline Carriers END ***************************
       */


      /**
       *************************** Rail Suppliers START ***************************
       */

      .when('/rail-suppliers', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailSuppliersList');
          }]
        }
      })

      .when('/rail-suppliers/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailSuppliersAddResource');
          }]
        }
      })

      .when('/rail-suppliers/:railSupId',
        {redirectTo: '/rail-suppliers/:railSupId/info'})

      .when('/rail-suppliers/:railSupId/:railSupTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailSuppliersResource');
          }]
        }
      })

      .when('/rail-suppliers/:railSupId/info/fare-classes/:railSupFareClassItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailSupplierFareClassesGridItem');
          }]
        }
      })

      /**
       *************************** Rail Suppliers END ***************************
       */


      /**
       *************************** Car Suppliers START ***************************
       */


      .when('/car-suppliers', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersList');
          }]
        }
      })

      .when('/car-suppliers/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersAddResource');
          }]
        }
      })

      .when('/car-suppliers/:carSupId',
        {redirectTo: '/car-suppliers/:carSupId/info'})

      .when('/car-suppliers/:carSupId/:carSupTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersResource');
          }]
        }
      })

      .when('/car-suppliers/:carSupId/:carSupTab/vehicles/:CarSupVhItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersVehiclesGridItem');
          }]
        }
      })

      .when('/car-suppliers/:carSupId/:carSupTab/locations/:CarSupLocItem', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersLocationsGridItem');
          }]
        }
      })

      /**
       *************************** Car Suppliers END ***************************
       */

      /**
       *************************** Vehicles START ***************************
       */

      .when('/cars', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VehiclesList');
          }]
        }
      })

      .when('/cars/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VehiclesAddResource');
          }]
        }
      })

      .when('/cars/:vehicleId',
      {redirectTo: '/cars/:vehicleId/info'})      

      .when('/cars/:vehicleId/:vehicleTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('VehiclesResource');
          }]
        }
      })
      
      /**
       *************************** Vehicles END ***************************
       */


      /**
       *************************** Hotels START ***************************
       */


      .when('/hotels', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelsList');
          }]
        }
      })

      .when('/hotels/edit/:hotelId', {
        template: `<lba-edit-hotel></lba-edit-hotel>`
      })

      /**
       *************************** Hotels END ***************************
       */


      /**
       *************************** POI START ***************************
       */


      .when('/points-of-interest', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('PointsOfInterestList');
          }]
        }
      })

      /**
       *************************** POI END ***************************
       */


      /**
       *************************** airports START ***************************
       */

      .when('/airports', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirportsList');
          }]
        }
      })

      .when('/airports/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirportsAddResource');
          }]
        }
      })

      .when('/airports/:airportId',
        {redirectTo: '/airports/:airportId/info'})

      .when('/airports/:airportId/:airportTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AirportsResource');
          }]
        }
      })

      /**
       *************************** airports END ***************************
       */


      /**
       *************************** rail stations START ***************************
       */


      .when('/rail-stations', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailStationsList');
          }]
        }
      })

      .when('/rail-stations/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailStationsAddResource');
          }]
        }
      })

      .when('/rail-stations/:railStationId',
        {redirectTo: '/rail-stations/:railStationId/info'})

      .when('/rail-stations/:railStationId/:railStationTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailStationsResource');
          }]
        }
      })

      .when('/rail-stations/:railStationId/info/suppliers/:railStationSup', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailStationsSuppliersItem');
          }]
        }
      })

      /**
       *************************** rail stations END ***************************
       */


      /**
       *************************** rail cards START ***************************
       */

      .when('/rail-cards', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailCardsList');
          }]
        }
      })

      .when('/rail-cards/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailCardsAddResource');
          }]
        }
      })

      .when('/rail-cards/:railCardId',
        {redirectTo: '/rail-cards/:railCardId/info'})

      .when('/rail-cards/:railCardId/:railCardTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('RailCardsResource');
          }]
        }
      })

      .when('/rail-cards/:railCardId/info/accepted-suppliers/:railCardSup', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('AcceptedSuppliersItem');
          }]
        }
      })

      /**
       *************************** rail cards END ***************************
       */


      /**
       *************************** car supplier locations START ***************************
       */

      .when('/car-supplier-locations', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersLocationsList');
          }]
        }
      })

      .when('/car-supplier-locations/:carSupLocationId',
      {redirectTo: '/car-supplier-locations/:carSupLocationId/info'})

      .when('/car-supplier-locations/:carSupLocationId/info', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CarSuppliersLocationsResource');
          }]
        }
      })

      /**
       *************************** hotel suppliers START ***************************
       */


      .when('/hotel-suppliers', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelSupplierMembershipProgramsList');
          }]
        }
      })

      .when('/hotel-suppliers/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelSupplierMembershipProgramsAddResource');
          }]
        }
      })

	  .when('/hotel-suppliers/:hotelSupId',
        {redirectTo: '/hotel-suppliers/:hotelSupId/info'})
		
      .when('/hotel-suppliers/:hotelSupId/:hotelSupTab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelSupplierMembershipProgramsResource');
          }]
        }
      })

      /**
       *************************** hotel suppliers END ***************************
       */



      /**
       *************************** micro-debtor START ***************************
       */

      // .when('/ctm-debtors', {
      //   template: rootRouteTemplate,
      //   controller: ['targetName', rootRouteController],
      //   controllerAs: 'vm',
      //   resolve: {
      //     targetName: [() => {
      //       return injectTarget('CtmDebtorsList');
      //     }]
      //   }
      // })
      //
      // .when('/ctm-debtors/add', {
      //   template: rootRouteTemplate,
      //   controller: ['targetName', rootRouteController],
      //   controllerAs: 'vm',
      //   resolve: {
      //     targetName: [() => {
      //       return injectTarget('CtmDebtorsAddResource');
      //     }]
      //   }
      // })
      //
      // .when('/ctm-debtors/:ctmDebtorId',
      //   {redirectTo: '/ctm-debtors/:ctmDebtorId/info'})
      //
      // .when('/ctm-debtors/:ctmDebtorId/:ctmDebtorTab', {
      //   template: rootRouteTemplate,
      //   controller: ['targetName', rootRouteController],
      //   controllerAs: 'vm',
      //   resolve: {
      //     targetName: [() => {
      //       return injectTarget('CtmDebtorsResource');
      //     }]
      //   }
      // })


      /**
       *************************** micro-debtor END ***************************
       */


      .when('/features', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FeaturesList');
          }]
        }
      })

      .when('/features/add', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FeaturesAddResource');
          }]
        }
      })

      .when('/features/:featureID', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('FeaturesResource');
          }]
        }
      })

      //#region Products

      .when('/product/ctm-portal', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmPortalProductByDebtorList');
          }]
        }
      })

      .when('/product/ctm-mobile', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmMobileProductByDebtorList');
          }]
        }
      })

      .when('/product/ctm-approve', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmApproveProductByDebtorList');
          }]
        }
      })

      .when('/product/hotel-reviews', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelReviewsResource');
          }]
        }
      })

      .when('/product/hotel-reviews', {redirectTo: '/product/hotel-reviews/settings'})

      .when('/product/hotel-reviews/:tab', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('HotelReviewsResource');
          }]
        }
      })

      .when('/hotel-reviews-search', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmHotelReviewsList');
          }]
        }
      })

      .when('/product/lightning-book', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmLightningProductByDebtorList');
          }]
        }
      })

      .when('/product/ride-share', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmRideShareProductByDebtorList');
          }]
        }
      })

      .when('/product/risk', {
        template: rootRouteTemplate,
        controller: ['targetName', rootRouteController],
        controllerAs: 'vm',
        resolve: {
          targetName: [() => {
            return injectTarget('CtmRiskProductByDebtorList');
          }]
        }
      })

      .when('/hotel-rankings', {
        controller: () => {         
          window && window.svelte && window.svelte.hotelRankings();
        },
        template: '<div id="hotel-rankings" />',
      })


      //#endregion

      .otherwise({
        template: redirectTemplate,
        controller: [rootRouteController],
        controllerAs: 'vm',
      })


  };

  RouterConfig.$inject = $inject;

  return RouterConfig;
  };


// WEBPACK FOOTER //
// ./src/config/routerConfig.js